class Common{
    constructor(){
        this.methods = {
            login: '/api/common/login'
        };
        this._csrf_data = {
            time: false,
            nameHeaderCsrf: 'X-CSRFToken',
            nameParamCsrf: false
        };
        this._user = {
            auth: false
        };
    }

    postData(url, data) {
        // Default options are marked with *
        return fetch(url, {
            body: JSON.stringify(data), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, same-origin, *omit
            headers: {
                //    'user-agent': 'Mozilla/4.0 MDN Example',
                'Content-Type': 'application/json',
                [this._csrf_data.nameHeaderCsrf]: this._csrf_data.nameParamCsrf
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
            .then(response => response.json()) // parses response to JSON
            .catch(response => Object.assign({'result': -1}))
    }

    postForm(url, data, success, error){
        let formData = new FormData();
        for (let [k, v] of Object.entries(data)) {
            if(k === 'page') {
                for (let v2 of Object.values(v)) {
                    formData.append('page[]', v2);
                }
            } else if (v !== null && typeof (v) === "object" && v.hasOwnProperty('name')){
                for (let i of v) {
                    formData.append(k, i);
                }
            }
            else {
                formData.append(k, v);
            }
        }
        // for (let [k, v] of Object.entries(data)) {
        //     if(k === 'page') {
        //         for (let v2 of Object.values(v)) {
        //             formData.append('page[]', v2);
        //         }
        //     } else if (typeof (v) === "object" && v != null) {
        //         if (typeof (v.name) === "undefined") {
        //             for (let i of v) {
        //                 formData.append(k, i);
        //             }
        //         }
        //     }
        //     else {
        //         formData.append(k, v);
        //     }
        // }
        return fetch(url, {
            body: formData, // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, same-origin, *omit
            headers: {
                [this._csrf_data.nameHeaderCsrf]: this._csrf_data.nameParamCsrf
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
            .then(response => response.json())
            .then((result)=>{
                if(success){
                    success(result);
                }
            }, (err)=>{
                if(error){
                    error(err);
                }
            });
    }

    getStatusState(success, error){
        let now = new Date();
        if(!this._csrf_data.time || (this._csrf_data.time && (now.getTime() - this._csrf_data.time.getTime()) > 300000)){
            this.getStatus(success, error);
        }else{
            if(success){
                success(this._user);
            }
        }
    }

    getStatus(success, error){
        fetch('/api/common/status',{credentials: "include"})
            .then(res => res.json())
            .then((result)=>{
                this._csrf_data.time = new Date();
                this._csrf_data.nameParamCsrf = result.csrf;

                this._user.auth = result.auth ? result.auth : false;
                if(result.auth){
                    this._user.email = result.user.email;
                    this._user.username = result.user.username;
                    this._user.first_name = result.user.first_name;
                    this._user.last_name = result.user.last_name;
                }
                if(success){
                    success(result);
                }
            }, (err)=>{
                if(error){
                    error(err);
                }
            });
    }

    api(method, data, success, error){
        if(!this._csrf_data.time){
            const inst = this;
            this.getStatus(function () {
                inst.api(method, data, success, error);
            }, function (err) {
                if(error){
                    error(err);
                }
            });
            return;
        }
        if(method == 'logout'){
            this._csrf_data.time = false;
        }
        this.postData(this.methods[method], data)
            .then((result)=>{
                if(success)
                    success(result);
            })
            .catch(err=>{
                if(error)
                    error(err);
            });
    }

    apiForm(method, data, success, error){
        if(!this._csrf_data.time){
            const inst = this;
            this.getStatus(function () {
                inst.apiForm(method, data, success, error);
            }, function (err) {
                if(error){
                    error(err);
                }
            });
            return;
        }
        this.postForm(this.methods[method], data)
            .then((result)=>{
                if(success)
                    success(result);
            })
            .catch(err=>{
                if(error)
                    error(err);
            });
    }

    apiGet(method, success, error){
        fetch(this.methods[method], {credentials: "include"})
            .then(res => res.json())
            .then((result)=>{
                if(success){
                    success(result);
                }
            }, (err)=>{
                if(error){
                    error(err);
                }
            });
    }

    apiGetById(method, id, success, error){
        fetch(this.methods[method] + id, {credentials: "include"})
            .then(res => res.json())
            .then((result)=>{
                if(success){
                    success(result);
                }
            }, (err)=>{
                if(error){
                    error(err);
                }
            });
    }

    apiGetUrl(url, success, error){
        fetch(url, {credentials: "include"})
            .then(res => res.json())
            .then((result)=>{
                if(success){
                    success(result);
                }
            }, (err)=>{
                if(error){
                    error(err);
                }
            });
    }
}

const serverApi = new Common();
Object.freeze(serverApi);

export default serverApi;


// WEBPACK FOOTER //
// ./src/api/Common.js